import React, { useContext } from 'react';
import { MainInfoTab } from './components/MainInfoTab';
import AdditionallyTab from './components/AdditionallyTab/AdditionallyTab';
import { IUserProfileContext, UserProfileContext } from '../../../../userProfileState/userProfileContext';

const Tabs: React.FC = () => {
	const { userInfoVisibleForm } = useContext<IUserProfileContext>(UserProfileContext);

	const getTab = () => {
		switch (userInfoVisibleForm) {
			case 'mainForm':
				return <MainInfoTab />;
			case 'additionally':
				return <AdditionallyTab />;
			default:
				return null;
		}
	};

	return <>{getTab()}</>;
};

export default Tabs;
